import SearchBar from 'components/Autosuggest/Autosuggest';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchPaginatedAccounts, fetchUsersForAccount } from 'services';
import { showError, sortArray } from 'utils';
import styles from './index.module.scss';

const AccountAutosuggest = props => {
  const [loading, setLoading] = useState(false);
  const [defaultSuggestions, setDefaultSuggestions] = useState<Record<string, any>[]>([]);
  const [users, setUsers] = useState<Record<string, any>[]>([]);
  const [usersLoading, setUsersLoading] = useState<boolean>(true);
  const [accountSelected, setAccountSelected] = useState<boolean>(false);
  const [accountName, setAccountName] = useState<string>('');
  const {
    value,
    onSelect,
    showUserSelect,
  } = props;

  const fetchDefaultSuggestions = async () => {
    setLoading(true);
    try {
      const { items } = await fetchPaginatedAccounts({
        page: 0,
        limit: 1000,
      }); 
      setDefaultSuggestions(items.map(suggestion => ({
        id: suggestion.objectId,
        // eslint-disable-next-line @typescript-eslint/camelcase
        full_name: suggestion.name,
        displayName: suggestion.name,
        email: suggestion.email?.toLowerCase(),
        phone: suggestion.phone,
        address: suggestion.address,
      })));
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDefaultSuggestions();
  }, []);

  const fetchAccountUsers = async (id: string) => {
    setUsersLoading(true);
    try {
      const response = await fetchUsersForAccount({
        page: 0,
        limit: 100,
        accountId: id,
      });
      setUsers(response.items);
    } catch (e) {
      showError(e);
    } finally {
      setUsersLoading(false);
    }
  };
  
  const getAccountUsers = () => {
    const getUserOptions = () => sortArray(users, 'full_name').map((user, i) => (
      <option key={i} value={user.objectId}>{user.full_name}</option>),
    );

    const handleUserChange = (id: string) => {
      const [user] = users.filter(user => user.objectId === id);
      onSelect(user);
    };

    return (
      <select
        value={value.objectId || ''}
        disabled={usersLoading}
        className={'form-control mt-4'}
        onChange={e => handleUserChange(e.target.value)}
      >
        <option value={''} hidden={!!value?.full_name}>Select a User</option>
        {users.length && getUserOptions()}
      </select>
    );
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    if (!showUserSelect) {
      onSelect(suggestion.id);
    } else {
      onSelect({});
      setAccountSelected(true);
      fetchAccountUsers(suggestion.id);
    }
  };
  
  if (loading) return <Loading type={'mini'} />;
  
  return (
    <div>
      <div className={styles['autosuggest-container']}>
        <SearchBar
          isUser={true}
          local={true}
          value={accountName}
          setValue={value => setAccountName(value)}
          defaultSuggestions={defaultSuggestions}
          searchAPI={() => { }}
          searchAPIParam={''}
          onSuggestionClicked={handleSuggestionClick}
        />
      </div>
      {(showUserSelect && !!accountSelected) && getAccountUsers()}
    </div>
  );
};

export default AccountAutosuggest;